import { h } from '@stencil/core';
import state from 'store';
import { i18n } from 'i18n';
import { DebugDTO } from 'client/types';
import { copyToClipboard } from 'utils/utils';

export default function DebugModal({ show }: { show: boolean }) {
  const onClose = () => {
    state.showFullScreenModal = null;
  };

  const debugStr = (debug?: DebugDTO) => {
    if (!debug) {
      return '';
    } else {
      var tools = debug.tools?.map(t => ({ ...t, params: JSON.parse(t.params) }));
      return JSON.stringify(
        {
          tools: tools,
          metadata: debug.metadata,
          attributes: debug.attributes,
        },
        null,
        3,
      );
    }
  };

  return show ? (
    <div id="debug-modal" class="eva-3-modal-fullscreen -show-modal">
      <div class="modal-fullscreen-header">
        <i class="eva-3-icon-cross  modal-fullscreen-close" role="button" tabindex="0" onClick={onClose} />
        <div class="modal-fullscreen-header-container">
          <h4 class="modal-fullscreen-title">
            <i class={`eva-3-icon-question-circle -eva-3-icon-sm -eva-3-mr-sm`} /> {i18n.t.chat.message.actions.debug}
          </h4>
        </div>
      </div>
      <div class="modal-fullscreen-content">
        <div class="eva-3-textarea -lg ">
          <div class="textarea-container">
            <textarea
              class="textarea-tag"
              style={{
                height: 'calc(100vh - 150px)',
                resize: 'vertical',
              }}
              readonly
              value={debugStr(state.debug)}
            ></textarea>
          </div>
        </div>

        <button type="button" class="eva-3-btn -md -primary -eva-3-mt-sm" onClick={() => copyToClipboard(debugStr(state.debug))}>
          <em class="btn-text">Copiar</em>
        </button>
      </div>
    </div>
  ) : null;
}
